import type { Resource } from '../../';
export const general_total: Resource = {"default":"Total"};
